import GjsTemplateBlank from "./Blank";
import GjsTemplateBranch from "./Branch";
import GjsTemplateContent from "./Content";
import GjsTemplateImageMenu from "./ImageMenu";
import GjsTemplateIntro from "./Intro";
import GjsTemplateFullPageText from "./FullPageText";
import GjsTemplateExitScenario from "./ExitScenario";
import GjsTemplateLegacyContent from "./LegacyContent";
import { getUuidv4, JsonCopy } from "../../../classes/utilities/Misc";
import { UIVersions } from "../../../interfaces/Misc";
import { IGrapesJSComponent, IGrapesJSProjectData, IVisageTemplate } from "../../../interfaces/VisageUI";
import UITemplateTypes from "../../uisystem/templates/types";
import { GjsAttributeNames, GjsComponentTypes } from "../gjsplugin/Enums";

export function emptyGrapesProject(): IGrapesJSProjectData
{
	const baseContainerId = "C" + getUuidv4();

	const baseContainer : IGrapesJSComponent = {
		type: GjsComponentTypes.Div,
		components: [],
		attributes: {
			id: baseContainerId,
			[GjsAttributeNames.VoiceOver]: "",
			[GjsAttributeNames.NoActions]: "",
			[GjsAttributeNames.NotDeletable]: "",
			[GjsAttributeNames.NotResizable]: "",
			[GjsAttributeNames.NotCopiable]: "",
		},
		name: "Template Container",
		resizable: false,
		draggable: false,
		selectable: false,
		highlightable: false,
		stylable: false,
	};

	return { 
		assets: [], 
		pages: [
			{
				id: getUuidv4(),
				type: "main",
				frames: [
					{
						id: getUuidv4(),
						component: {
							components: [baseContainer],
							stylable: [],
							type: "wrapper",
						}
					}
				]
			}
		], 
		styles: [
			{
				selectors: [`#${baseContainerId}`],
				style: {
					"position": "relative",
					"width": "100%",
					"height": "100%",
					"display": "flex",
					"align-items": "center",
					"justify-content": "center",
				}
			}
		] 
	};
}

export function isTemplateDefault(template: IVisageTemplate)
{
	return Object.keys(defaultTemplates).some((key) => template.defaultTemplateID === key);
}

export function generateDefaultVisageTemplates()
{
	const output: {[key: string]: IVisageTemplate} = {};

	for(const [key, value] of Object.entries<IGrapesJSProjectData>(defaultTemplates))
	{
		const id = getUuidv4();
		output[id] = {
			id: id,
			name: key,
			sourceTemplateId: "",
			content: JsonCopy(value),
			previousState: JsonCopy(value),
			isDefault: true,
			defaultTemplateID: key,
			version: UIVersions.new20,
		};
	}

	createQuizResultsTemplate(output);

	return output;
}

export function createQuizResultsTemplate(templates: {[key: string]: IVisageTemplate})
{
	const id = getUuidv4();
	templates[id] = {
		id: id,
		name: UITemplateTypes.QUIZ_RESULTS,
		sourceTemplateId: UITemplateTypes.QUIZ_RESULTS,
		content: {} as IGrapesJSProjectData,
		previousState: {} as IGrapesJSProjectData,
		isDefault: true,
		defaultTemplateID: UITemplateTypes.QUIZ_RESULTS,
		version: UIVersions.old10,
	};
}

// DEFAULT UI TEMPLATE DATA
export const defaultTemplates = {
	"Blank": GjsTemplateBlank,
	"Branch": GjsTemplateBranch,
	"Content": GjsTemplateContent,
	"Exit Scenario": GjsTemplateExitScenario,
	"Full Page Text": GjsTemplateFullPageText,
	"Image Menu": GjsTemplateImageMenu,
	"Intro": GjsTemplateIntro,
	"Legacy Content": GjsTemplateLegacyContent,
};